import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Grid, Button } from '@material-ui/core';
import styled from 'styled-components';
import { modalsToggle, adminSetCounter } from 'actions';
import { ADMIN_VEHICLE_STATUS } from 'constants';
import { AcceptOfferModal, ActiveOfferInfo, parseAdminAuctionOfferInfo, SendOfferModal } from 'components/Offers';
import { Vehicle } from 'types/vehicle';
import { auctionOfferStatuses } from 'utils/statusCalculator';
import { useAdminCounterControls, useNoSelectorVehicleOfferAuctionById } from 'hooks';
import { useCurrentUser } from 'hooks/selectors';
import { ActionDivider } from 'pages/Admin/ViewVehicle/components/UI';

const CounterControlsWrapper = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
  margin-top: 12px;

  & > button {
    flex: 1 1 100%;
  }
`;

const ControlButton = styled(Button)<{ textColor: string; color: any }>`
  border-radius: 6px;
  width: 94px;
  height: 44px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  background: ${props => props.color};
  color: ${props => props.textColor};
  font-size: 14px;
  font-weight: 500;

  &:hover {
    background: ${props => props.color};
  }
`;

type Props = {
  vehicle: Vehicle;
};

export const PrivateOfferCounters = ({ vehicle }: Props) => {
  const offerAuction = useNoSelectorVehicleOfferAuctionById(vehicle.id);

  const user = useCurrentUser();
  const { sellerAmount, adminAmount, buyerAmount } = parseAdminAuctionOfferInfo(offerAuction);
  const status = auctionOfferStatuses(vehicle, offerAuction, user);

  return (
    <>
      {offerAuction && <ActiveOfferInfo offerAuction={offerAuction} vehicle={vehicle} />}

      {/* {Boolean(sellerAmount || adminAmount || buyerAmount) && (
        <Grid item xs={12}>
          <div style={{ margin: '10px 0' }} />
        </Grid>
      )} */}

      {status === ADMIN_VEHICLE_STATUS.BUYER_COUNTER_SENT && <BuyerCounterControls vehicle={vehicle} />}

      {Boolean(sellerAmount || adminAmount || buyerAmount) && (
        <Grid item xs={12}>
          <ActionDivider />
        </Grid>
      )}
    </>
  );
};

export const BuyerCounterControls = ({ vehicle }: Props) => {
  const buttons = useAdminCounterControls(vehicle.id);

  return (
    <>
      <CounterControlsWrapper>
        {buttons.map(btn => (
          <ControlButton key={btn.title} color={btn.color} textColor={btn.textColor} onClick={btn.onClick}>
            {btn.title}
          </ControlButton>
        ))}
      </CounterControlsWrapper>
      <AcceptOfferModal vehicleTitle={`${vehicle.year} ${vehicle.make} ${vehicle.model}`} vehicleId={vehicle.id} />
      <SendOfferModal maxAmount={vehicle.reserve_price} form={`sendVehicleOffer-${vehicle.id}`} vehicle={vehicle} />
    </>
  );
};
